<app-tab-bar
  [tabs]="viewService?.availableViews"
  [activeTab]="(viewService.selectedView | async)?.name"
  (changeTab)="viewService.setSelectedView($event)"
  *ngIf="!!viewService && viewService.shouldDisplayViewControls()"
></app-tab-bar>
